var map = {
	"./bg-BG.json": [
		4767,
		4767
	],
	"./de-DE.json": [
		21443,
		1443
	],
	"./en-US.json": [
		2104,
		2104
	],
	"./es-ES.json": [
		19650,
		9650
	],
	"./fr-FR.json": [
		80884,
		884
	],
	"./it-IT.json": [
		14146,
		4146
	],
	"./nl-NL.json": [
		27786,
		7786
	],
	"./pt-BR.json": [
		73240,
		3240
	],
	"./sv-SE.json": [
		55132,
		5132
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 71029;
module.exports = webpackAsyncContext;